import posthog from "posthog-js";

type Event =
  | { event: "SIGN_UP"; data: { email?: string } }
  | { event: "ONBOARDING_COMPLETED" }
  | { event: "VARIANT_CREATED" }
  | { event: "VARIANT_CHAT_MESSAGE_SENT" }
  | { event: "TRAFFIC_SOURCE_CREATED" }
  | { event: "CONVERSION_RULE_CREATED" }
  | { event: "CLIENT_ERROR"; data: { traceId?: string } };

export class Tracking {
  static init() {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      ui_host: "https://eu.posthog.com",
      person_profiles: "always",
      session_recording: { maskAllInputs: false },
      loaded: () => {
        // @ts-expect-error - not something we want to use in TypeScript land
        window.posthog = posthog;
      },
      disable_session_recording: !import.meta.env.PROD,
    });
  }

  static identify({
    userId,
    email,
    orgId,
  }: {
    userId: string;
    email?: string;
    orgId?: string;
  }) {
    if (!import.meta.env.PROD) {
      return;
    }

    posthog.identify(userId, { orgId, email });
    if (orgId) {
      posthog.group("org", orgId);
    }
  }

  static alias(userId: string) {
    if (!import.meta.env.PROD) {
      return;
    }

    posthog.alias(userId);
  }

  static capture(event: Event) {
    if (!import.meta.env.PROD) {
      return;
    }

    posthog.capture(event.event, "data" in event ? event.data : undefined);
  }
}
